import { fromEvent, Observable } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { toggleUppercaseInRange } from '../../helpers/uppercase';
import { InteractionAction, InteractionHandler, InteractionTrigger } from '../../interactionEvent';
import { Service } from '../base/service';
import { ElementSelectionService } from './elementSelectionService';
import { createElementEffectService } from './elementService';

export type ElementUppercaseServiceOptions = {
  onInteraction?: InteractionHandler;
};

export function createElementUppercaseService(
  element$: Observable<Element | null>,
  selectionService: ElementSelectionService,
  options: ElementUppercaseServiceOptions = {},
): Service {
  return createElementEffectService(element$, element =>
    fromEvent<KeyboardEvent>(element, 'keydown').pipe(
      tap(event => {
        if (event.defaultPrevented || event.repeat) {
          return;
        }

        const isUppercaseShortcut = event.shiftKey && event.key === 'F3';
        if (!isUppercaseShortcut) {
          return;
        }

        event.preventDefault();

        const { selection } = selectionService;
        if (!selection) {
          return;
        }

        const { isBackward } = selection;
        let { range } = selection;
        if (range.collapsed) {
          return;
        }

        range = toggleUppercaseInRange(element, range);
        selectionService.selectWithRange(range, isBackward);

        if (options.onInteraction) {
          options.onInteraction({
            trigger: InteractionTrigger.KEYBOARD_SHORTCUT,
            action: InteractionAction.SET_UPPERCASE,
          });
        }
      }),
      share(),
    ),
  );
}
